import React, { useState } from 'react';
import LayoutContainer from 'components/layout/LayoutContainer';
import AdminHeader from 'components/header/index';
import Card from 'components/inputs/Card';
import CpoInformation from './CPOInformation';
import Connectivity from './Connectivity';
import Financials from './Financials';
import { useParams } from 'react-router-dom';

const AddCpo = () => {
  const [currentTab, setCurrentTab] = useState('CPOInformation');

  const { ocpiId } = useParams();

  const setTab = (tab) => {
    setCurrentTab(tab);
  };

  const infoToConnectivity = () => {
    setCurrentTab('Connectivity');
  };
  const connectivityToFinancials = () => {
    setCurrentTab('Financials');
  };

  return (
    <React.Fragment>
      <LayoutContainer>
        <AdminHeader title={`${ocpiId ? 'Edit' : 'Add'} CPO`} backTo={`/cpo`} />
        <div className="page-content-wrapper scrollable">
          <div className="add-vehicle-page-main">
            <Card>
              <div>
                <div className="tab-block">
                  <div className="tab-nav-block">
                    <a
                      href="#"
                      className={`tab-nav__item ${currentTab === 'CPOInformation' ? 'active' : ''}`}
                      onClick={() => setTab('CPOInformation')}
                      data-content="tab-profile"
                    >
                      CPO Information
                    </a>
                    <a
                      href="#"
                      className={`tab-nav__item ${currentTab === 'Connectivity' ? 'active' : ''}`}
                      onClick={() => setTab('Connectivity')}
                      data-content="tab-bookings"
                    >
                      Connectivity
                    </a>
                    <a
                      href="#"
                      className={`tab-nav__item ${currentTab === 'Financials' ? 'active' : ''}`}
                      onClick={() => setTab('Financials')}
                      data-content="tab-transactions"
                    >
                      Financials
                    </a>
                  </div>
                </div>
              </div>
            </Card>

            {currentTab === 'CPOInformation' && <CpoInformation infoToConnectivity={infoToConnectivity} />}
            {currentTab === 'Connectivity' && <Connectivity connectivityToFinancials={connectivityToFinancials} />}
            {currentTab === 'Financials' && <Financials />}
          </div>
        </div>
      </LayoutContainer>
    </React.Fragment>
  );
};
export default AddCpo;
